import { updatePreviewEntry } from "../../store/actions/client";
import { interactiveClientSelector, supportedFieldsSelector, disableReadOnlyFieldsSelector } from "../../store/selectors/clientSettings";
import { TextPreview } from "./TextPreview";
import { NumberFieldsPreview } from "./NumberPreview";
import { StaticTextPreview } from "./StaticTextPreview";
import { LinkPreview } from "./LinkPreview";
import { RatingPreview } from "./RatingPreview";
import { SingleChoicePreview } from "./SingleChoicePreview";
import { MultipleChoicePreview } from "./MultipleChoicePreview";
import { CheckboxPreview } from "./CheckboxPreview";
import { TimePreview } from "./TimePreview";
import { DatePreview } from "./DatePreview";
import { PhotoPreview } from "./PhotoPreview";
import { SignaturePreview } from "./SignaturePreview";
import { BarcodePreview } from "./BarcodePreview";
import { DrawingPreview } from "./DrawingPreview";
import { GPSPreview } from "./GPSPreview";
import { CalculationPreview } from "./CalculationPreview";
import { SumPreview } from "./SumPreview";
import { MirrorPreview } from "./MirrorPreview";
import { PaymentPreview } from "./PaymentPreview";
import { UnsupportedPreview } from "./UnsupportedPreview";
import { useDispatch, useSelector } from 'react-redux';
export const getPreviewComponentByType = type => {
  const types = {
    Text: TextPreview,
    Number: NumberFieldsPreview,
    Date: DatePreview,
    Time: TimePreview,
    Checkbox: CheckboxPreview,
    'Static Text': StaticTextPreview,
    'Multiple Choice': MultipleChoicePreview,
    'Single Choice': SingleChoicePreview,
    Link: LinkPreview,
    Rating: RatingPreview,
    Photo: PhotoPreview,
    Signature: SignaturePreview,
    Barcode: BarcodePreview,
    Drawing: DrawingPreview,
    GPS: GPSPreview,
    Calculation: CalculationPreview,
    Sum: SumPreview,
    Mirror: MirrorPreview,
    Payment: PaymentPreview,
    Unsupported: UnsupportedPreview
  };
  return types[type] || TextPreview;
};
export const checkSupported = (type, supportedFields) => {
  return supportedFields ? supportedFields.includes(type) : true;
};
export const ClientField = ({
  entry
}) => {
  const disableReadOnly = useSelector(disableReadOnlyFieldsSelector);
  if (disableReadOnly) {
    entry = {
      ...entry,
      read_only: false
    };
  }
  const {
    type,
    guid,
    touched,
    errors = '',
    conditionMet
  } = entry;
  const interactiveClient = useSelector(interactiveClientSelector);
  const supportedFields = useSelector(supportedFieldsSelector);
  const isSupported = checkSupported(type, supportedFields);
  const fieldType = isSupported ? type : 'Unsupported';
  const Field = getPreviewComponentByType(fieldType);
  const dispatch = useDispatch();
  const onBlur = () => {
    if (!touched) {
      dispatch(updatePreviewEntry({
        guid,
        touched: true
      }));
    }
  };
  return <>
      {conditionMet && <div className={`
          preview--field
          ${fieldType === 'Unsupported' && 'field--unsupported'}
          `}>
          <Field {...entry} onBlur={onBlur} errors={touched && errors} update={(value, meta = {}) => interactiveClient && dispatch(updatePreviewEntry({
        ...meta,
        guid,
        value
      }))} id={guid} />
        </div>}
    </>;
};